import React from 'react'
import { FormattedMessage } from 'react-intl'
import Status from '../../Status'
import appMessages from 'utils/messages'

const StatusRenderer = ({ name, colorMap = {}, def, isGrid }) => {
  if (!name) return null
  const isProgress = def?.isProgress && def.isProgress(name)
  
  return (
    <Status
      isProgress={isProgress}
      color={colorMap[name]}
      name={<FormattedMessage {...appMessages[name]} />}
      isGrid={isGrid}
    />
  )
}

export default StatusRenderer